"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scala": {
    "ebc7a53e": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "skipSearch": false
    }],
    "minuta": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de65464a": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-in-campoleone": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0281a7f2": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina-campidoglio": [{
      "hkey": "085fd273",
      "slug": "scala",
      "name": "Scala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;